<template>
  <div class="event-rule-popup">
    <div class="event-rule-popup-shade"></div>
    <div class="event-rule-popup-sroll">
      <div class="event-rule-popup-content">
        <p class="event-rule-popup-title">{{ letter.shareRule }}</p>
        <div class="text-wrap">
          <div class="rule-item rule-item1">{{ letter.ruleText1 }}</div>
          <div class="rule-item rule-item2">{{ letter.ruleText2 }}</div>
          <div class="rule-item rule-item3">{{ letter.ruleText3 }}</div>
          <div class="rule-text-title1">{{ letter.ruleTableTitle1 }}</div>
          <table class="rule-table1">
            <caption></caption>
            <thead>
              <tr>
                <th>{{ letter.eventGainCondition }}</th>
                <th>{{ letter.ruleTableHead3 }}</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>{{ letter.eventSuccInvite }}</td>
                <td>{{ letter.couponText1 }}</td>
              </tr>
              <tr>
                <td>{{ letter.eventInviteGainOne }}</td>
                <td>{{ letter.couponText2 }}</td>
              </tr>
              <tr>
                <td>{{ letter.eventInviteGainTwo }}</td>
                <td>{{ letter.couponText3 }}</td>
              </tr>
            </tbody>
          </table>
          <div class="rule-item rule-item4">{{ letter.ruleText4 }}</div>
          <div class="rule-text-title2">{{ letter.ruleTableTitle2 }}</div>
          <table class="rule-table2">
            <caption></caption>
            <thead>
              <tr>
                <th>{{ letter.ruleTableHead2 }}</th>
                <th>{{ letter.ruleTableHead3 }}</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>{{ letter.ruleTableContent1 }}</td>
                <td>{{ letter.couponText4 }}</td>
              </tr>
              <tr>
                <td>{{ letter.ruleTableContent2 }}</td>
                <td>{{ letter.couponText5 }}</td>
              </tr>
            </tbody>
          </table>
          <div class="rule-item rule-item5">{{ letter.ruleText5 }}</div>
          <div class="rule-item rule-item6">{{ letter.ruleText6 }}</div>
          <div class="rule-item rule-item7">{{ letter.ruleText7 }}</div>
          <div class="rule-item rule-item8">{{ letter.ruleText8 }}</div>
          <div class="rule-item rule-item9">{{ letter.ruleText9 }}</div>
          <div class="rule-item rule-item10">{{ letter.ruleText10 }}</div>
        </div>
        <a class="event-rule-popup-close j-click-rule-close" href="javascript:;" @click="hidePopup"></a>
      </div>
    </div>
  </div>
</template>

<script type="text/javascript">
export default {
  name: 'eventRulePopup',
  props: [
  ],
  data() {
    return {
    }
  },
  computed: {
    letter() {
      return this.$store.state.letter
    }
  },
  created() {
    window.activityDataLayer.push({
      eventName: "click_button",
      eventType: '活动规则',
      aid: "ztmslgpay",
      gameId: 191
    })
  },
  methods: {
    hidePopup() {
      this.$emit('closeRulePopup')
    }
  },
  components: {
  }
}
</script>

<style scoped lang="scss">
@import '@assets/scss/officialStore/officialStore.scss';

.event-rule-popup {
  position: fixed;
  left: 0;
  top: 0;
  z-index: 1001;
  width: 100%;
  height: 100%;

  &-shade {
    position: absolute;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, .4);
  }

  &-sroll {
    position: absolute;
    left: 50%;
    top: 50%;
    width: 691px;
    height: 100%;
    transform: translate(-50%, -50%);
    overflow: auto;
    overflow-x: hidden;
  }

  ::-webkit-scrollbar {
    width: 0px;
  }

  ::-webkit-scrollbar-track {
    border-radius: 4px;
  }

  ::-webkit-scrollbar-thumb {
    background: #ffffff;
    border-radius: 4px;
  }

  &-content {
    width: 691px;
    height: 1120px;
    background-size: 100% 100%;
    @psetbg ('share-popup-rule.png', false, false);
  }

  &-title {
    position: absolute;
    top: 30px;
    font-size: 44px;
    color: #c1a15e;
    font-weight: 600;
    text-align: center;
    width: 100%;
  }

  .text-wrap {
    position: absolute;
    top: 95px;
    left: 50%;
    transform: translateX(-50%);
    width: 640px;
    height: 800px;
  }

  .rule-item {
    width: 100%;
    font-size: 20px;
    color: #ffffff;
    text-align: left;
    line-height: 26px;
  }

  .rule-text-title1 {
    width: 100%;
    font-size: 24px;
    color: #c1a15e;
    text-align: left;
    line-height: 30px;
    margin-top: 5px;
  }

  .rule-table1 {
    border-collapse: unset;
    border-spacing: unset;
    margin: auto;
    margin-top: 10px;
    margin-bottom: 10px;
    width: 570px;
    height: 165px;
    border: 1px solid var(--event-block-border);

    thead {
      background-color: var(--event-block-border);
      color: var(--event-title);
    }

    td {
      border: 1px solid var(--event-block-border);
      height: 38px;
      text-align: center;
      font-size: 18px;
      color: var(--event-title);
      white-space: pre-wrap;
    }

    th {
      height: 45px;
      text-align: center;
      font-size: 20px;
      color: var(--event-title);
      white-space: pre-wrap;
      border: none;
    }
  }

  .rule-text-title2 {
    width: 100%;
    font-size: 24px;
    color: #c1a15e;
    text-align: left;
    line-height: 30px;
    margin-top: 5px;
  }

  .rule-table2 {
    border-collapse: unset;
    border-spacing: unset;
    margin: auto;
    margin-top: 10px;
    margin-bottom: 10px;
    width: 570px;
    height: 140px;
    border: 1px solid var(--event-block-border);

    thead {
      background-color: var(--event-block-border);
      color: var(--event-title);
    }

    td {
      border: 1px solid var(--event-block-border);
      height: 42px;
      text-align: center;
      font-size: 18px;
      color: var(--event-title);
      white-space: pre-wrap;
    }

    th {
      height: 48px;
      text-align: center;
      font-size: 20px;
      color: var(--event-title);
      white-space: pre-wrap;
      border: none;
    }
  }

  &-close {
    position: absolute;
    right: 31px;
    top: 30px;
    background-size: cover;
    cursor: pointer;
    @psetbg ('close.png');
  }
}
</style>
